<template>
  <div id="app">
    <div class="create-main">
      <!-- ── Topbar ── -->
      <div class="create-topbar">
        <div class="create-topbar__left">
          <button class="create-btn-back" @click="goBackToList()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <line
                x1="19"
                y1="12"
                x2="5"
                y2="12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <polyline
                points="12,19 5,12 12,5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            Volver
          </button>
        </div>
        <div class="create-topbar__center">
          <h1 class="create-topbar__title">
            {{ $t("main.jobs.messages.addJob") }}
          </h1>
        </div>
        <div class="create-topbar__actions">
          <button class="create-btn-secondary" @click="clearForm()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polyline
                points="1,4 1,10 7,10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
              <path
                d="M3.51 15a9 9 0 1 0 .49-4.95"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            {{ $t("main.jobs.buttons.clean") }}
          </button>
          <button class="create-btn-primary" @click="submitForm()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polyline
                points="20,6 9,17 4,12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            {{ $t("main.jobs.buttons.create") }}
          </button>
        </div>
      </div>

      <!-- ── Cuerpo con scroll ── -->
      <div class="create-body">
        <!-- ── Card campos principales ── -->
        <div class="create-card">
          <div class="create-card__header">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                stroke="#0284C7"
                stroke-width="2"
                fill="none"
              />
              <line
                x1="16"
                y1="2"
                x2="16"
                y2="6"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="8"
                y1="2"
                x2="8"
                y2="6"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="3"
                y1="10"
                x2="21"
                y2="10"
                stroke="#0284C7"
                stroke-width="2"
              />
            </svg>
            <span class="create-card__title">Datos principales</span>
          </div>

          <el-form ref="form" :model="form" class="create-form">
            <div class="create-fields-grid">
              <!-- Fila 1: Nº Orden | Carretilla -->
              <div class="create-field">
                <label class="create-field__label">{{
                  tField("orderNumber")
                }}</label>
                <el-input
                  v-model="form.orderNumber"
                  class="create-input"
                  :placeholder="tPlaceholder('orderNumber')"
                />
              </div>

              <div class="create-field">
                <label class="create-field__label">{{
                  tField("recorderName")
                }}</label>
                <el-select
                  v-model="form.recorderId"
                  class="create-input"
                  :placeholder="tPlaceholder('recorderName')"
                >
                  <el-option
                    v-for="fork in valoresCarretillas"
                    :key="fork.identifier"
                    :label="fork.name"
                    :value="fork.identifier"
                  />
                </el-select>
              </div>

              <!-- Fila 2: Fecha inicio | vacío -->
              <div class="create-field">
                <label class="create-field__label">{{
                  tField("createdAt")
                }}</label>
                <el-date-picker
                  v-model="form.startDay"
                  type="date"
                  value-format="timestamp"
                  class="create-input"
                  :placeholder="tPlaceholder('startDay')"
                />
              </div>

              <div
                class="create-field"
                :style="{ visibility: form.startDay ? 'visible' : 'hidden' }"
              >
                <label class="create-field__label">{{
                  tField("endDay")
                }}</label>
                <el-date-picker
                  v-model="form.endDay"
                  type="date"
                  value-format="timestamp"
                  class="create-input"
                  :placeholder="tPlaceholder('endDay')"
                />
              </div>

              <!-- Fila 3: Hora inicio | Hora fin -->
              <div class="create-field">
                <label class="create-field__label">{{
                  tField("videoStart")
                }}</label>
                <el-time-picker
                  v-model="form.videoStart"
                  type="time"
                  class="create-input"
                  :placeholder="tPlaceholder('videoStart')"
                />
              </div>

              <div class="create-field">
                <label class="create-field__label">{{
                  tField("videoEnd")
                }}</label>
                <el-time-picker
                  v-model="form.finishTime"
                  type="time"
                  class="create-input"
                  :placeholder="tPlaceholder('finishTime')"
                />
              </div>
            </div>
          </el-form>
        </div>

        <!-- ── Card atributos adicionales ── -->
        <div
          class="create-card"
          v-if="
            (additionalAttributes && additionalAttributes.length) ||
            selectedRecorderHasCameraGroup ||
            orderTypes.length
          "
        >
          <el-collapse v-model="activeNames" class="create-collapse">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="create-collapse__title">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <circle
                      cx="12"
                      cy="12"
                      r="3"
                      stroke="#0284C7"
                      stroke-width="2"
                      fill="none"
                    />
                    <path
                      d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"
                      stroke="#0284C7"
                      stroke-width="2"
                      fill="none"
                    />
                  </svg>
                  <span>{{ tField("addicional") }}</span>
                </div>
              </template>

              <div class="create-fields-grid create-fields-grid--additional">
                <div
                  class="create-field"
                  v-for="field in additionalAttributes"
                  :key="field"
                >
                  <label class="create-field__label">{{ tField(field) }}</label>
                  <el-input
                    v-model="form[field]"
                    class="create-input"
                    :placeholder="tPlaceholder(field)"
                  />
                </div>

                <!-- Streaming Event: visible solo si el recorder tiene cameraGroup -->
                <div class="create-field" v-if="selectedRecorderHasCameraGroup">
                  <label class="create-field__label">Streaming Event</label>
                  <el-select
                    v-model="form.streamingEventId"
                    class="create-input"
                    placeholder="Seleccionar evento"
                    clearable
                  >
                    <el-option
                      v-for="event in streamingEvents"
                      :key="event.id"
                      :label="event.placeholder"
                      :value="event.id"
                    />
                  </el-select>
                </div>

                <!-- Type: visible siempre que haya tipos disponibles -->
                <div class="create-field" v-if="orderTypes.length">
                  <label class="create-field__label">{{
                    tField("type")
                  }}</label>
                  <el-select
                    v-model="form.type"
                    class="create-input"
                    :placeholder="tPlaceholder('type')"
                    clearable
                  >
                    <el-option
                      v-for="t in orderTypes"
                      :key="t"
                      :label="t"
                      :value="t"
                    />
                  </el-select>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- ── Botones móviles (duplicado para pantallas pequeñas) ── -->
        <div class="create-footer-actions">
          <button class="create-btn-secondary" @click="clearForm()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polyline
                points="1,4 1,10 7,10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
              <path
                d="M3.51 15a9 9 0 1 0 .49-4.95"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            {{ $t("main.jobs.buttons.clean") }}
          </button>
          <button class="create-btn-primary" @click="submitForm()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <polyline
                points="20,6 9,17 4,12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                fill="none"
              />
            </svg>
            {{ $t("main.jobs.buttons.create") }}
          </button>
        </div>
      </div>
      <!-- /create-body -->
    </div>
  </div>
</template>

<script>
import ordersApi from "@/services/orders.api";
import { getStreamingEvents } from "@/services/streamingEvent.api";
import storage from "../utils/storage";

export default {
  name: "OrderCreate",
  data() {
    return {
      form: {
        id: "",
        operatorId: "",
        operatorName: "",
        container: "",
        recorderId: "",
        plate: "",
        seal: "",
        orderNumber: "",
        clientName: "",
        videoStart: "",
        finishTime: "",
        startDay: "",
        warehouse: "",
        packingList: "",
        countId: "",
        streamingEventId: "",
        type: "",
        endDay: "",
      },
      activeNames: [""],
      valoresCarretillas: [],
      valoresID: storage.loadUsername(),
      additionalAttributes: [],
      streamingEvents: [],
      orderTypes: [],
    };
  },
  computed: {
    selectedRecorderHasCameraGroup() {
      if (!this.form.recorderId) return false;
      const recorder = this.valoresCarretillas.find(
        (r) => r.identifier === this.form.recorderId
      );
      return !!(recorder && recorder.cameraGroup);
    },
    tField() {
      return (key) => this.$t(`main.jobs.fields.${key}`);
    },
    tPlaceholder() {
      return (key) => this.$t(`main.jobs.placeholders.${key}`);
    },
    tAlert() {
      return (key) => this.$t(`main.jobs.alerts.${key}`);
    },
  },
  async mounted() {
    this.getrecorders();
    this.getOrderTypes();
    try {
      const res = await fetch("/config.json");
      const cfg = await res.json();
      this.additionalAttributes = cfg.additionalAttributes;
    } catch (e) {
      console.error("No se pudo cargar config.json", e);
    }
  },
  watch: {
    "form.recorderId"() {
      this.form.streamingEventId = "";
      if (this.selectedRecorderHasCameraGroup) {
        this.getStreamingEvents();
      } else {
        this.streamingEvents = [];
      }
    },
    "form.startDay"(newVal) {
      if (!this.form.endDay) {
        this.form.endDay = newVal;
      }
    },
  },
  methods: {
    async getOrderTypes() {
      try {
        this.orderTypes = await ordersApi.getTypes();
      } catch (err) {
        console.error(err);
        this.orderTypes = [];
      }
    },
    async getStreamingEvents() {
      try {
        this.streamingEvents = await getStreamingEvents();
      } catch (err) {
        console.error(err);
        this.streamingEvents = [];
      }
    },
    async getrecorders() {
      try {
        const response = await ordersApi.getrecorders();
        console.log("→ recibido de API:", response);
        this.valoresCarretillas = response;
        console.log(
          "→ asignado a valoresCarretillas:",
          this.valoresCarretillas
        );
        this.$nextTick(() => {
          console.log("→ tras nextTick:", this.valoresCarretillas);
          this.$forceUpdate();
        });
      } catch (err) {
        console.error(err);
      }
    },
    clearForm() {
      this.form = {
        clientName: "",
        operatorId: "",
        operatorName: "",
        container: "",
        recorderId: "",
        plate: "",
        orderNumber: "",
        seal: "",
        startDay: "",
        videoStart: "",
        finishTime: "",
        warehouse: "",
        packingList: "",
        countId: "",
        streamingEventId: "",
        type: "",
        endDay: "",
      };
    },
    goBackToList() {
      this.$router.push("/orders");
    },
    remoteFind(query) {
      this.list.filter((item) => {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
    },
    async submitForm() {
      const {
        orderNumber,
        recorderId,
        videoStart,
        startDay,
        endDay,
        finishTime,
      } = this.form;

      if (
        !orderNumber ||
        !recorderId ||
        !videoStart ||
        !startDay ||
        !finishTime
      ) {
        this.$message(this.tAlert("order"));
        return;
      }
      const videoStartDate = new Date(startDay);
      const videoEndDate = new Date(endDay || startDay);
      videoStartDate.setHours(
        videoStart.getHours(),
        videoStart.getMinutes(),
        videoStart.getSeconds()
      );
      videoEndDate.setHours(
        finishTime.getHours(),
        finishTime.getMinutes(),
        finishTime.getSeconds()
      );

      if (videoStartDate > videoEndDate) {
        this.$alert(this.tAlert("wrongDates"));
        return;
      }

      const params = {
        operatorId: this.form.operatorId,
        operatorName: this.form.operatorName,
        container: this.form.container,
        recorderId: this.form.recorderId,
        plate: this.form.plate,
        seal: this.form.seal,
        orderNumber: this.form.orderNumber,
        clientName: this.form.clientName,
        videoStart: videoStartDate,
        videoEnd: videoEndDate,
        warehouse: this.form.warehouse,
        packingList: this.form.packingList,
        countId: this.form.countId,
        streamingEventId: this.form.streamingEventId || null,
        type: this.form.type || null,
      };

      try {
        await ordersApi.postOrder(params);
        this.clearForm();
        this.$message(this.$t("main.jobs.messages.confirmCreate"));
        this.$router.push("/orders");
      } catch (error) {
        this.$message(
          `${this.$t("main.jobs.messages.createError")}: ${error.message}`
        );
      }
    },
  },
};
</script>

<style>
/* ── Layout ───────────────────────────────────────────────────── */
.create-main {
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* crece con el contenido */
  background: #f0f4f8;
}

/* ── Topbar ───────────────────────────────────────────────────── */
.create-topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
  padding: 13px 22px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.create-topbar__left {
  flex-shrink: 0;
}

.create-topbar__center {
  flex: 1;
}

.create-topbar__title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.create-topbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Back button */
.create-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 6px 12px;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-family: inherit;
  transition: border-color 0.15s, color 0.15s;
}
.create-btn-back:hover {
  border-color: #0284c7;
  color: #0284c7;
}

/* Primary button */
.create-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #0284c7;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.35);
  transition: background 0.15s, box-shadow 0.15s;
}
.create-btn-primary:hover {
  background: #0369a1;
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.45);
}

/* Secondary button */
.create-btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  color: #64748b;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  transition: border-color 0.15s, color 0.15s;
}
.create-btn-secondary:hover {
  border-color: #94a3b8;
  color: #475569;
}

/* ── Scrollable body ──────────────────────────────────────────── */
.create-body {
  padding-bottom: 24px; /* breathing room at bottom */
  overflow: visible;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Cards ────────────────────────────────────────────────────── */
.create-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.create-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.create-card__title {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

/* ── Form & fields grid ───────────────────────────────────────── */
.create-form {
  padding: 20px;
}

.create-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 28px;
}

.create-fields-grid--additional {
  padding: 16px 20px 20px;
}

.create-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.create-field__label {
  font-size: 11px;
  font-weight: 600;
  color: #0284c7;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* Make el-input, el-select, el-date-picker fill the cell */
.create-input,
.create-input .el-input,
.create-input .el-input__inner {
  width: 100% !important;
}

.create-input .el-input__inner {
  border-color: #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #0f172a;
  height: 38px;
  transition: border-color 0.15s;
}
.create-input .el-input__inner:focus {
  border-color: #0284c7;
}
.create-input .el-input__inner::placeholder {
  color: #94a3b8;
}

/* ── Collapse ─────────────────────────────────────────────────── */
.create-collapse {
  border: none !important;
}

.create-collapse .el-collapse-item__header {
  padding: 12px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0 !important;
  border-top: none !important;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  height: auto;
  line-height: 1.4;
}

.create-collapse .el-collapse-item__wrap {
  border-bottom: none !important;
}

.create-collapse .el-collapse-item__content {
  padding: 0;
}

.create-collapse__title {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Footer actions (visible en pantallas pequeñas) ───────────── */
.create-footer-actions {
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
}

@media (max-width: 640px) {
  .create-topbar__actions {
    display: none;
  }
  .create-footer-actions {
    display: flex;
  }
  .create-fields-grid {
    grid-template-columns: 1fr;
  }
}
</style>
